<template>
  <div class="wrap">
    <div @click="openDialog">
      <slot></slot>
    </div>
    <el-dialog
      destroy-on-close
      :visible.sync="dialogVisible"
      title="导入意向学员"
      append-to-body
      width="500px"
    >
      <div v-show="currentStep === 1" class="content-wrap1">
        <p class="title">1、下载意向学员模板</p>
        <p class="content">请根据模板要求，填写对应信息。</p>
        <div class="link" @click="downloadTemplate">下载模板</div>
        <p class="title">2、选择需要导入的excel模板文件</p>
        <p class="content">填写错误的数据不会导入列表。</p>
        <common-uploader @change="handleUpload">
          <el-button
            v-if="!selectFileName"
            class="mwow-button-filled success upload-btn"
            >添加文件</el-button
          >
        </common-uploader>
        <div v-if="selectFileName" class="select-file-wrap">
          <p class="name">{{ selectFileName }}</p>
          <el-button class="mwow-button info" @click="clearDeleteSelect"
            >删除</el-button
          >
        </div>
        <p class="title">3、导入说明</p>
        <p class="content">
          导入成功后，学员会在意向列表中显示；<br />导入失败的学员可以预览查看失败原因，修改后重新导入。
        </p>
        <div class="btn-wrap">
          <el-button
            class="mwow-button-filled success mini"
            @click="handleImport"
            v-debounce="2000"
            >导入</el-button
          >
        </div>
      </div>
      <div v-show="currentStep === 2" class="content-wrap2">
        <p>导入中 <i class="el-icon-loading"></i></p>
      </div>
      <div v-if="currentStep === 3" class="content-wrap3">
        <el-dialog
          :visible.sync="visibilityDialog"
          append-to-body
          destroy-on-close
          :showClose="false"
          :close-on-click-modal="false"
          width="80%"
        >
          <div style="font-size: 14px; padding-bottom: 20px">
            {{ studentTotal }}个意向学员数据，成功导入{{
              success_total
            }}个意向学员数据，<span style="color: #e12727"
              >{{ abnormal_total }}个意向学员异常，
              {{ mobile_repeat_total }}个意向学员的手机号已存在</span
            >
          </div>
          <el-table
            class="mwow-table"
            size="mini"
            :data="tableData"
            style="width: 100%"
            tooltip-effect="dark"
            max-height="453"
            :row-class-name="tableRowClassName"
            :header-cell-style="{ background: '#f2f6fa' }"
          >
            <el-table-column label="排序" width="50">
              <template slot-scope="scope">{{ scope.$index + 1 }}</template>
            </el-table-column>
            <el-table-column label="姓名" prop="student_name" min-width="150">
              <template slot-scope="scope">
                <span
                  v-show="!scope.row.student_name_flag"
                  @dblclick="scope.row.student_name_flag = true"
                  >{{ scope.row.student_name || "-" }}</span
                >
                <el-input
                  v-model="scope.row.student_name"
                  v-show="scope.row.student_name_flag"
                  @change="checkRow(scope.row)"
                  @blur="scope.row.student_name_flag = false"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column label="区号" prop="area_code" min-width="150">
              <template slot-scope="scope">
                <el-select
                  v-model="scope.row.area_code"
                  placeholder="请选择"
                  @change="checkRow(scope.row)"
                >
                  <el-option
                    v-for="item in areaCodeList"
                    :key="item.code_id"
                    :value="item.completeCodeName"
                    :label="item.completeCodeName"
                  ></el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column label="手机号" prop="mobile" min-width="120">
              <template slot-scope="scope">
                <p
                  v-show="!scope.row.mobile_flag"
                  @dblclick="scope.row.mobile_flag = true"
                >
                  {{ scope.row.mobile || "-" }}
                </p>
                <el-input
                  v-model="scope.row.mobile"
                  v-show="scope.row.mobile_flag"
                  @change="checkRow(scope.row)"
                  @blur="scope.row.mobile_flag = false"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column label="微信号" prop="wechat" min-width="120">
              <template slot-scope="scope">
                <p
                  v-show="!scope.row.wechat_flag"
                  @dblclick="scope.row.wechat_flag = true"
                >
                  {{ scope.row.wechat || "-" }}
                </p>
                <el-input
                  v-model="scope.row.wechat"
                  v-show="scope.row.wechat_flag"
                  @change="checkRow(scope.row)"
                  @blur="scope.row.wechat_flag = false"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column
              label="市场顾问"
              prop="market_staff"
              min-width="150"
            >
              <template slot-scope="scope">
                <el-select
                  v-model="scope.row.market_staff"
                  placeholder="请选择"
                  @change="checkRow(scope.row)"
                >
                  <el-option
                    v-for="(item, index) in marketStaffList"
                    :key="index"
                    :label="item"
                    :value="item"
                  ></el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column label="出现方式" prop="appear" min-width="100">
              <template slot-scope="scope">
                <el-select
                  v-model="scope.row.appear"
                  placeholder="请选择"
                  @change="
                    () => {
                      scope.row.source = '';
                      scope.row.sourceChannelList = [];
                    }
                  "
                >
                  <el-option
                    v-for="item in studentAppearList"
                    :key="item.name"
                    :label="item.name"
                    :value="item.name"
                  >
                  </el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column label="来源渠道" prop="source" min-width="150">
              <template slot-scope="scope">
                <el-select
                  v-model="scope.row.source"
                  placeholder="请选择"
                  @change="checkRow(scope.row)"
                  @focus="handleSearchSource(scope.row)"
                >
                  <el-option
                    v-for="item in scope.row.sourceChannelList"
                    :key="item.name"
                    :label="item.name"
                    :value="item.name"
                  >
                  </el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column label="性别" prop="sex" min-width="100">
              <template slot-scope="scope">
                <el-select
                  v-model.number="scope.row.sex"
                  placeholder="请选择"
                  @change="checkRow(scope.row)"
                >
                  <el-option label="男" :value="'男'"></el-option>
                  <el-option label="女" :value="'女'"></el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column label="出生日期" prop="birthday" min-width="150">
              <template slot-scope="scope">
                <el-date-picker
                  v-model="scope.row.birthday"
                  type="date"
                  placeholder="选择日期"
                  @change="checkRow(scope.row)"
                  value-format="yyyy/MM/dd"
                >
                </el-date-picker>
              </template>
            </el-table-column>
            <el-table-column
              label="课程顾问"
              prop="follow_staff"
              min-width="150"
            >
              <template slot-scope="scope">
                <el-select
                  v-model="scope.row.follow_staff"
                  placeholder="请选择"
                  @change="checkRow(scope.row)"
                >
                  <el-option
                    v-for="(item, index) in staffList"
                    :key="index"
                    :label="item"
                    :value="item"
                  ></el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column
              label="监护人"
              prop="custody_staff"
              min-width="150"
            >
              <template slot-scope="scope">
                <span
                  v-show="!scope.row.custody_staff_flag"
                  @dblclick="scope.row.custody_staff_flag = true"
                  >{{ scope.row.custody_staff || "-" }}</span
                >
                <el-input
                  v-model="scope.row.custody_staff"
                  v-show="scope.row.custody_staff_flag"
                  @change="checkRow(scope.row)"
                  @blur="scope.row.custody_staff_flag = false"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column
              label="区号"
              prop="spare_area_code"
              min-width="150"
            >
              <template slot-scope="scope">
                <el-select
                  v-model="scope.row.spare_area_code"
                  placeholder="请选择"
                  @change="checkRow(scope.row)"
                >
                  <el-option
                    v-for="item in areaCodeList"
                    :key="item.code_id"
                    :value="item.completeCodeName"
                    :label="item.completeCodeName"
                  ></el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column
              label="备用号码"
              prop="spare_mobile"
              min-width="150"
            >
              <template slot-scope="scope">
                <span
                  v-show="!scope.row.spare_mobile_flag"
                  @dblclick="scope.row.spare_mobile_flag = true"
                  >{{ scope.row.spare_mobile || "-" }}</span
                >
                <el-input
                  v-model="scope.row.spare_mobile"
                  v-show="scope.row.spare_mobile_flag"
                  @change="checkRow(scope.row)"
                  @blur="scope.row.spare_mobile_flag = false"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column label="家庭住址" prop="address" min-width="150">
              <template slot-scope="scope">
                <span
                  v-show="!scope.row.address_flag"
                  @dblclick="scope.row.address_flag = true"
                  >{{ scope.row.address || "-" }}</span
                >
                <el-input
                  v-model="scope.row.address"
                  v-show="scope.row.address_flag"
                  @change="checkRow(scope.row)"
                  @blur="scope.row.address_flag = false"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column label="就读学校" prop="school" min-width="150">
              <template slot-scope="scope">
                <span
                  v-show="!scope.row.school_flag"
                  @dblclick="scope.row.school_flag = true"
                  >{{ scope.row.school || "-" }}</span
                >
                <el-input
                  v-model="scope.row.school"
                  v-show="scope.row.school_flag"
                  @change="checkRow(scope.row)"
                  @blur="scope.row.school_flag = false"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column label="意向科目" prop="subject" min-width="150">
              <template slot-scope="scope">
                <el-select
                  v-model="scope.row.subject"
                  placeholder="请选择"
                  style="width: 100%"
                  @change="checkRow(scope.row)"
                >
                  <el-option
                    v-for="item in subjectList"
                    :key="item.subject_id"
                    :label="item.subject_title"
                    :value="item.subject_title"
                  ></el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column
              label="进入公海"
              prop="is_potential"
              min-width="80"
            >
              <template slot-scope="scope">
                <el-select
                  v-model="scope.row.is_potential"
                  placeholder="请选择"
                  style="width: 100%"
                  @change="checkRow(scope.row)"
                >
                  <el-option label="是" value="是"></el-option>
                  <el-option label="否" value="否"></el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column label="备注" prop="remark" min-width="150">
              <template slot-scope="scope">
                <span
                  v-show="!scope.row.remark_flag"
                  @dblclick="scope.row.remark_flag = true"
                  >{{ scope.row.remark || "-" }}</span
                >
                <el-input
                  v-model="scope.row.remark"
                  v-show="scope.row.remark_flag"
                  @change="checkRow(scope.row)"
                  @blur="scope.row.remark_flag = false"
                  type="textarea"
                  maxlength="255"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column
              label="错误原因"
              prop="error_message"
              min-width="150"
            >
              <template slot-scope="scope">
                <span>{{ scope.row.error_message }}</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" min-width="100">
              <template slot-scope="scope">
                <el-button
                  class="mwow-button info"
                  @click="handleDelete(scope.row)"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <div class="footer">
            <div class="btns">
              <el-button class="mwow-button-filled mini" @click="handleCancel"
                >取消导入</el-button
              >
              <el-button
                class="mwow-button-filled success mini"
                @click="handleConfirm"
                v-debounce="1000"
                >确认导入</el-button
              >
            </div>
          </div>
        </el-dialog>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { importLoop } from "@/utils/import";
import commonUploader from "@/components/commonUploader.vue";
import { smsAreaCodeListApi } from "@/api/signIn";
import {
  sourceTypeSelectListApi,
  getStudentAppearListApi,
} from "@/api/storeManagement";
import { getLatentExcelApi } from "@/api/studentManage";
import { getSeleSubjectsList } from "@/api/globalSearch";
import {
  createImportTaskApi,
  importErrorVerifyApi,
  importErrorCreateApi,
} from "@/api/taskCenter";
export default {
  components: {
    commonUploader,
  },
  data() {
    return {
      dialogVisible: false,
      currentStep: 1,
      sampleLink: "",
      selectFileName: "",
      uploadFileKey: "",
      visibilityDialog: false,
      success_total: 0,
      abnormal_total: 0,
      mobile_repeat_total: 0,
      studentTotal: 0,
      tableData: [],
      uploadResult: {
        success: 0,
        total: 0,
        fail: 0,
        link: "",
      },
      areaCodeList: [],
      studentAppearList: [],
      staffList: [],
      marketStaffList: [],
      subjectList: [],
      tableTaskId: 0,
    };
  },
  methods: {
    handleCancel() {
      this.currentStep = 1;
      this.visibilityDialog = false;
    },
    handleConfirm() {
      let errorNum = 0;
      this.tableData.map((item) => {
        if (item.error_background === "error_background_color") {
          errorNum++;
        }
      });
      if (errorNum > 0) {
        this.$message({
          type: "error",
          message: "还存在" + errorNum + "条异常数据，请先处理",
        });
        return;
      }
      let tableList = [];
      this.tableData.map((val) => {
        tableList.push({
          student_name: val.student_name,
          area_code: val.area_code,
          mobile: val.mobile,
          wechat: val.wechat,
          market_staff: val.market_staff,
          appear: val.appear,
          source: val.source,
          sex: val.sex,
          birthday: val.birthday,
          follow_staff: val.follow_staff,
          custody_staff: val.custody_staff,
          spare_area_code: val.spare_area_code,
          spare_mobile: val.spare_mobile,
          address: val.address,
          school: val.school,
          subject: val.subject,
          is_potential: val.is_potential,
          remark: val.remark,
        });
      });
      importErrorCreateApi({
        task_id: this.tableTaskId,
        list: tableList,
      }).then((res) => {
        if (res.error_code === 0) {
          // 不等于null证明还有错误
          if (res.data !== null) {
            const _t = this;
            let newArr = [];
            _t.tableData.map((item, index) => {
              for (let key in res.data) {
                // 匹配
                if (index === Number(key)) {
                  item.error_message = res.data[key];
                  item.error_background = "error_background_color";
                  newArr.push(item);
                }
              }
            });
            _t.tableData = newArr;
            return;
          }
          this.$message({
            type: "success",
            message: `成功导入${this.studentTotal}条数据`,
          });
          this.visibilityDialog = false;
          this.dialogVisible = false;
          this.$emit("change");
        }
      });
    },
    tableRowClassName(row) {
      return row.row.error_background;
    },
    // 检查这一行有没有异常
    checkRow(val) {
      let option = {
        student_name: val.student_name,
        area_code: val.area_code,
        mobile: val.mobile,
        wechat: val.wechat,
        market_staff: val.market_staff,
        appear: val.appear,
        source: val.source,
        sex: val.sex,
        birthday: val.birthday,
        follow_staff: val.follow_staff,
        custody_staff: val.custody_staff,
        spare_area_code: val.spare_area_code,
        spare_mobile: val.spare_mobile,
        address: val.address,
        school: val.school,
        subject: val.subject,
        is_potential: val.is_potential,
        remark: val.remark,
      };
      importErrorVerifyApi(option).then((res) => {
        if (res.error_code === 0) {
          if (res.data.verify && res.data.error_type === 0) {
            // 校验完全通过
            val.error_background = "success_background_color";
            val.error_message = "-";
          } else if (res.data.verify && res.data.error_type === 2) {
            // 手机号码已存在
            val.error_background = "success_background_color";
            val.error_message = res.data.message;
          } else {
            // 校验不通过
            this.tableData.map((item) => {
              if (item.id === val.id) {
                item.error_message = res.data.message;
                item.error_background = "error_background_color";
              }
            });
          }
        }
      });
    },
    handleDelete(val) {
      for (let i = 0; i < this.tableData.length; i++) {
        if (this.tableData[i].id === val.id) {
          this.tableData.splice(i, 1);
          break;
        }
      }
    },
    openDialog() {
      if (!this.sampleLink) {
        getLatentExcelApi().then((res) => {
          this.sampleLink = res.data.excel_url;
        });
      }
      this.dialogVisible = true;
      this.currentStep = 1;
      this.clearDeleteSelect();
      smsAreaCodeListApi().then((res) => {
        if (res.error_code === 0) {
          res.data.ncn_list.unshift(...res.data.cn_list);
          res.data.ncn_list.map((item) => {
            item.completeCodeName = item.name + "+" + item.code;
          });
          this.areaCodeList = res.data.ncn_list;
        }
      });
      getSeleSubjectsList({
        page: 1,
        page_size: 500,
        status: 1,
      }).then((res) => {
        this.subjectList = res.data.list;
      });
      getStudentAppearListApi({
        page: 1,
        page_size: 500,
        status: 1,
      }).then((res) => {
        if (res.error_code === 0) {
          this.studentAppearList = res.data.list;
        }
      });
    },
    // 下载 xlsx 文件时，使用 a 标签有弊端，就是 edge 浏览器下载会出问题，则可以使用 iframe 来解决
    downloadTemplate() {
      let url = this.sampleLink; // 文件地址
      let iframe = document.createElement("iframe");
      iframe.src = url;
      iframe.style.display = "none";
      iframe.onload = function () {
        document.body.removeAttribute(iframe);
      };
      document.body.appendChild(iframe);
    },
    handleSearchSource(row) {
      if (!row.appear) {
        return false;
      }
      let target = this.studentAppearList.find((a) => {
        return a.name === row.appear;
      });
      if (target) {
        sourceTypeSelectListApi({ appear_id: target.id, status: 1 }).then(
          (result) => {
            row.sourceChannelList = result.data.list;
          }
        );
      }
    },
    handleClose() {
      this.dialogVisible = false;
    },
    handleUpload(data) {
      this.selectFileName = data.file_name;
      this.uploadFileKey = data.file_key;
    },
    clearDeleteSelect() {
      this.selectFileName = "";
      this.uploadFileKey = "";
    },
    handleImport() {
      if (!this.selectFileName || !this.uploadFileKey) {
        this.$message({
          type: "warning",
          message: "请先选择文件",
        });
        return false;
      }
      createImportTaskApi({
        type: 1,
        original_file_name: this.selectFileName.split(".")[0],
        file_path: this.uploadFileKey,
      }).then((res) => {
        if (res.error_code === 21001001) {
          this.$message({
            type: "error",
            message: res.message,
          });
        } else {
          this.currentStep = 2;
          this.tableTaskId = res.data.task_id;
          importLoop(res.data.task_id)
            .then((tableRes) => {
              const data = tableRes.data;
              this.success_total = data.success_total;
              this.abnormal_total = data.abnormal_total;
              this.mobile_repeat_total = data.mobile_repeat_total;
              this.studentTotal =
                data.success_total +
                data.abnormal_total +
                data.mobile_repeat_total;
              if (data.list.length > 0) {
                this.currentStep = 3;
                this.visibilityDialog = true;
                let num = 1;
                data.list.map((item) => {
                  item.sourceChannelList = [
                    {
                      source_id: item.source,
                      name: item.source,
                    },
                  ]; // 各自保存自己的来源渠道
                  item.sort = num++;
                  item.student_name_flag = false;
                  item.area_code_flag = false;
                  item.mobile_flag = false;
                  item.wechat_flag = false;
                  item.market_staff_flag = true;
                  item.source_flag = false;
                  item.sex_flag = false;
                  item.birthday_flag = false;
                  item.follow_staff_flag = false;
                  item.custody_staff_flag = false;
                  item.spare_area_code_flag = false;
                  item.spare_mobile_flag = false;
                  item.address_flag = false;
                  item.school_flag = false;
                  item.subject_flag = false;
                  item.remark_flag = false;
                  item.error_message_flag = false;
                  item.error_background =
                    item.error_type === 1
                      ? "error_background_color"
                      : "success_background_color";
                });
                this.tableData = data.list;
                this.staffList = data.staff_list;
                this.marketStaffList = data.market_staff_list;
              } else {
                this.$message({
                  type: "success",
                  message: `成功导入${this.studentTotal}条数据`,
                });
                this.visibilityDialog = false;
                this.dialogVisible = false;
                this.$emit("change");
              }
            })
            .catch(() => {
              this.currentStep = 1;
            });
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.wrap {
  display: inline-block;
}
.content-wrap1 {
  .title {
    font-size: 12px;
    font-weight: 500;
    color: #5c5d5e;
    line-height: 13px;
    margin-bottom: 12px;
  }
  .content {
    font-size: 12px;
    font-weight: 400;
    color: #ffb940;
    line-height: 16px;
    margin-bottom: 12px;
  }
  .link {
    display: inline-block;
    font-size: 14px;
    font-weight: 400;
    text-decoration: underline;
    color: #07d1aa;
    line-height: 13px;
    margin-bottom: 20px;
    cursor: pointer;
  }
  .upload-btn {
    margin-bottom: 20px;
  }
  .select-file-wrap {
    display: flex;
    margin-bottom: 23px;
    .name {
      font-size: 14px;
      font-weight: 400;
      color: #07d1aa;
      line-height: 22px;
      margin-right: 15px;
    }
  }
  .btn-wrap {
    text-align: right;
    margin: 20px -20px 0 -20px;
    padding: 20px 20px 0 0;
    border-top: 1px solid #e7e8ea;
  }
}
.content-wrap2 {
  height: 351px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  p {
    font-size: 16px;
  }
}
.content-wrap3 {
  height: 351px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  .icon {
    margin-bottom: 20px;
  }
  .title {
    font-size: 14px;
    font-weight: 500;
    color: #5c5d5e;
    line-height: 13px;
    margin-bottom: 10px;
  }
  .content {
    font-size: 12px;
    font-weight: 400;
    color: #5c5d5e;
    line-height: 13px;
    margin-bottom: 10px;
    span {
      margin: 0 3px;
    }
  }
  .mwow-button-filled {
    margin-top: 7px;
  }
}
.footer {
  margin: 0 -20px;
  padding: 20px 20px 0 20px;
  .btns {
    text-align: center;
    .mwow-button-filled {
      margin-left: 10px;
    }
  }
}
/deep/ .error_background_color {
  background-color: #fde7e7 !important;
  td {
    background-color: #fde7e7 !important;
  }
}
/deep/ .success_background_color {
  background-color: #f3f3f3 !important;
}
/deep/ .has-gutter {
}
</style>
